export enum StudyMaterialTypeEnum {
	Course = 'COURSE',
	Quiz = 'QUIZ',
	Study = 'STUDY'
}
